module.exports = __webpack_public_path__ + "static/media/2.1f6bd708.jpg";